<template>
  <div ref="sorting" class="sorting" :class="{ 'sorting--open': isOpen }">
    <div class="sorting__trigger" @click="togleModal">
      {{ $t('filter.sorting.sort_by') }}
      <span class="sorting__icon icon-chevron"></span>
    </div>
    <SortingOptions
      :sortOptions="sortOptions"
      :activeOption="activeOption"
      class="sorting__options--desktop"
      @selected="onSortingOptionsSelected"
    />
  </div>
</template>

<script>
import SortingOptions from './SortingOptions.vue'

export default {
  name: 'Sorting',
  components: { SortingOptions },
  props: {
    sortOptions: {},
    activeOption: {},
  },
  data() {
    return {
      isOpen: false,
    }
  },
  mounted() {
    document.body.addEventListener('click', this.handleOutClick)
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.handleOutClick)
  },
  methods: {
    onSortingOptionsSelected(option) {
      this.$emit('selected', option)
      this.closeModal()
    },
    togleModal() {
      this.isOpen = !this.isOpen
    },
    closeModal() {
      this.isOpen = false
    },
    handleOutClick(e) {
      if (e.target !== this.$refs.sorting && !this.$refs.sorting.contains(e.target))
        this.closeModal()
    },
  },
}
</script>

<style lang="scss" scoped>
@import './Sorting';
</style>
